module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet durationText = ''\nconst eventTS = ((((resourceData || {}).data || {}).attributes || {}).event || {}).startTS\nif(eventTS){\nconst langCode = storage.langCode || 'de-at'\nconst eventPart = ((((resourceData || {}).data || {}).attributes || {}).eventParts || {})[langCode] || {}\nconst duration = utils.moment.duration(utils.moment(eventTS).diff(utils.moment()))\nconst durations = {\ndays: '00',\nhours: '00',\nminutes: '00',\nseconds: '00'\n}\nif(storage.isClient){\ndurations.days  = String(Math.floor(duration.as('days'))).padStart(2,'0');\ndurations.hours = String(Math.floor(duration.subtract(durations.days, 'days').as('hours'))).padStart(2,'0');\ndurations.minutes = String(Math.floor(duration.subtract(durations.hours, 'hours').as('minutes'))).padStart(2,'0');\ndurations.seconds = String(Math.floor(duration.subtract(durations.minutes, 'minutes').as('seconds'))).padStart(2,'0');\n}\nlet eventLink = (eventPart.path ? ` onclick=\"window.location='${eventPart.path}'\"` : '')\nconst hideDetailPage = ((eventPart.coreInformation || {}).hideEventDetailPage || 0) === 1;\nif (hideDetailPage) {\neventLink = ` onclick=\"window.location='/de/termine-und-anmeldung'\"`;\n}\ndurationText = `\n<div class=\"countdown${eventLink ? ' clickable' : ''}\" id=\"eventCountdown\" data-ets=\"${new Date(eventTS).getTime()}\" title=\"${eventPart.title.replace(/\\\"/g,\"'\")}\"${eventLink}>\n<div class=\"b\">\n<div class=\"e\">${eventPart.title}</div>\n<div class=\"w\">\n<div class=\"c\"><div class=\"n\" id=\"cntdwn_d\">${durations.days}</div><div class=\"t\">Tage</div></div>\n<div class=\"d\">:</div>\n<div class=\"c\"><div class=\"n\" id=\"cntdwn_h\">${durations.hours}</div><div class=\"t\">Stunden</div></div>\n<div class=\"d\">:</div>\n<div class=\"c\"><div class=\"n\" id=\"cntdwn_m\">${durations.minutes}</div><div class=\"t\">Minuten</div></div>\n<div class=\"d\">:</div>\n<div class=\"c\"><div class=\"n\" id=\"cntdwn_s\">${durations.seconds}</div><div class=\"t\">Sekunden</div></div>\n</div>\n</div>\n</div>\n`;\n}\n%><%-durationText%>"
  , __filename = "components\\templates\\events\\timer.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let durationText = ''
const eventTS = ((((resourceData || {}).data || {}).attributes || {}).event || {}).startTS
if(eventTS){
const langCode = storage.langCode || 'de-at'
const eventPart = ((((resourceData || {}).data || {}).attributes || {}).eventParts || {})[langCode] || {}
const duration = utils.moment.duration(utils.moment(eventTS).diff(utils.moment()))
const durations = {
days: '00',
hours: '00',
minutes: '00',
seconds: '00'
}
if(storage.isClient){
durations.days  = String(Math.floor(duration.as('days'))).padStart(2,'0');
durations.hours = String(Math.floor(duration.subtract(durations.days, 'days').as('hours'))).padStart(2,'0');
durations.minutes = String(Math.floor(duration.subtract(durations.hours, 'hours').as('minutes'))).padStart(2,'0');
durations.seconds = String(Math.floor(duration.subtract(durations.minutes, 'minutes').as('seconds'))).padStart(2,'0');
}
let eventLink = (eventPart.path ? ` onclick="window.location='${eventPart.path}'"` : '')
const hideDetailPage = ((eventPart.coreInformation || {}).hideEventDetailPage || 0) === 1;
if (hideDetailPage) {
eventLink = ` onclick="window.location='/de/termine-und-anmeldung'"`;
}
durationText = `
<div class="countdown${eventLink ? ' clickable' : ''}" id="eventCountdown" data-ets="${new Date(eventTS).getTime()}" title="${eventPart.title.replace(/\"/g,"'")}"${eventLink}>
<div class="b">
<div class="e">${eventPart.title}</div>
<div class="w">
<div class="c"><div class="n" id="cntdwn_d">${durations.days}</div><div class="t">Tage</div></div>
<div class="d">:</div>
<div class="c"><div class="n" id="cntdwn_h">${durations.hours}</div><div class="t">Stunden</div></div>
<div class="d">:</div>
<div class="c"><div class="n" id="cntdwn_m">${durations.minutes}</div><div class="t">Minuten</div></div>
<div class="d">:</div>
<div class="c"><div class="n" id="cntdwn_s">${durations.seconds}</div><div class="t">Sekunden</div></div>
</div>
</div>
</div>
`;
}

    ; __line = 42
    ; __append(durationText)
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components\templates\events\timer.ejs

}